export const PreviousCouponsActions= {
	
	GetCouponImages_GET :{
		NEW:"GetCouponImages_GET_NEW",
		SUCCESS:"GetCouponImages_GET_SUCCESS",
		FAILED:"GetCouponImages_GET_FALIURE",
		LOADING:"GetCouponImages_GET_LOADING",
		UPDATE:"DisableGetCouponImages_Update_SUCCESS",
	},
	
}


export const GetCouponImagesStatus ={

	GetCouponImages_GET :{
		NEW:"GetCouponImages_GET_NEW",
		SUCCESS:"GetCouponImages_GET_SUCCESS",
		FAILED:"GetCouponImages_GET_FALIURE",
		LOADING:"GetCouponImages_GET_LOADING",
	}

}
